import * as React from 'react';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { Icon } from '../Icon/Icon.js';
import './RequiredAsterisk.scss.js';

const bem = Bem.create("vai-required-asterisk");
const RequiredAsterisk = ({ className, hidden }) => {
  return /* @__PURE__ */ React.createElement(Icon, {
    name: VaiIcon.Required,
    className: addClass(bem.block(hidden && "hidden"), className)
  });
};

export { RequiredAsterisk };
